/**
 * Визначення темного фону під логотипом.
 *
 * Тему закладу задає getStart().styleWeB, і кольори лягають CSS-змінними на
 * body, тож наперед не відомо, на чому саме опиниться знак. Кольорові логотипи
 * на темних фонах зливаються, тому для них тримаємо білі версії з тих самих
 * брендбуків, а тут вирішуємо, коли їх брати.
 *
 * Цей файл має ідентичну копію в qr-menu — правити одночасно в обох.
 */

// Відносна яскравість sRGB.
const isDarkColor = (color) => {
  const parts = String(color).match(/[\d.]+/g);
  if (!parts || parts.length < 3) return false;
  const [r, g, b] = parts.map(Number);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 < 0.5;
};

// Власний фон у логотипа прозорий, тож піднімаємось до першого предка
// з непрозорим фоном — саме на ньому він і опиниться.
const findBackgroundColor = (node) => {
  while (node && node !== document.documentElement) {
    // v-if лишає в DOM коментар-плейсхолдер, а на ньому getComputedStyle кидає.
    if (node.nodeType !== 1) {
      node = node.parentElement;
      continue;
    }
    const color = window.getComputedStyle(node).backgroundColor;
    const parts = String(color).match(/[\d.]+/g);
    const alpha = parts && parts.length > 3 ? Number(parts[3]) : 1;
    if (parts && alpha > 0) return color;
    node = node.parentElement;
  }
  return "";
};

export function isOnDarkSurface(node) {
  return isDarkColor(findBackgroundColor(node));
}
